import ContactDomain from '../../domains/ContactDomain'
import TireDomain from '../../domains/TireDomain'
import WheelDomain from '../../domains/WheelDomain'
import PoPreferenceDomain from '../../domains/PoPreferenceDomain'

export const load = (localAccount, state) => {
	let object = {} 

	object.accountType = 'LBB'
	object.dealerId = localAccount.dealerLocation.dealerId
	object.dealerName = localAccount.dealerLocation.name
	object.dealerLocationId = localAccount.dealerLocationId
	object.billTo = localAccount.dealerLocation.accountNumber
	object.storeAccountNumber = localAccount.accountNumber
	object.address = localAccount.address

	object.newHomePage = state.homePageDomain
	object.newHomePage.id = localAccount.id
	object.newHomePage.fleetId = localAccount.fleetId
	object.newHomePage.ersInstructions = localAccount.ersComments

	object.ersInstructions = object.newHomePage.ersInstructions

	object.isShipTo = false
	object.isBillTo = object.billTo !== undefined && object.billTo !== ''

	object.contacts = localAccount.contacts
		.map(contact => {
			var contactDomain = new ContactDomain(
				contact.name, 
				contact.title,
				getPhoneNumberFromContact(contact), 
				contact.email, 
				contact.id,
				getPhoneNumberIdFromContact(contact), 
				contact.contactTypes.map(c => c.name),
				contact.contactTypes.map(c => c.priority).reduce((prev, cur) => prev < cur ? prev : cur, Number.MAX_SAFE_INTEGER),
				contact.notifyWhenRolling, 
				contact.notifyWhenDispatched,
				false,
				contact.createdAt,
				contact.updatedAt)

			return contactDomain
		})
		.sort((a, b) => {
			if (a.priority > b.priority) return 1
			if (a.priority < b.priority) return -1

			return a.contactPrimaryName.localeCompare(b.contactPrimaryName)
		})


	if (!object.contacts || object.contacts.length === 0) { 
		object.contacts = []
	}

	//@TODO ask about LBBs and other accounts
	// object.newOtherAccounts = localAccount.otherAccounts.map(a => {
	// 	return new AccountNumbersDomain(a.otherAccountTypeId, a.name, a.accountNumber, a.id)
	// })

	if (!object.newOtherAccounts || object.newOtherAccounts.length === 0) { 
		object.newOtherAccounts = []
	}
	
	let poPref = localAccount.billingPreference
	let poPreference = new PoPreferenceDomain(false, false, '3', 0, false, true, null, null)

	if (poPref !== null) {
		poPreference = new PoPreferenceDomain(
			poPref.poRequired,
			poPref.poRequiredBefore !== undefined ? poPref.poRequiredBefore : false,
			(poPref.creditCardRulesId !== null) ? poPref.creditCardRulesId.toString() : '3',
			localAccount.billingPreferenceId,
			false,
			false,
			poPref.createdAt,
			poPref.updatedAt)
	}
	
	object.poPreference = poPreference

	let localAccountIdentifier = ''
	if (localAccount.address.address) {
		localAccountIdentifier += localAccount.address.address + ' '
	}
	if (localAccount.address.address2) {
		localAccountIdentifier += localAccount.address.address2 + ' '
	}
	if (localAccount.address.city) {
		localAccountIdentifier += localAccount.address.city + ', '
	}
	if (localAccount.address.state) {
		localAccountIdentifier += localAccount.address.state + ' '
	}
	if (localAccount.address.zip) {
		localAccountIdentifier += localAccount.address.zip + ' '
	}
	object.fleetLocationIdentifier = localAccountIdentifier

	let newTires = []
	if (localAccount.axleTirePreference && localAccount.axleTirePreference.axleTireDetails) {
		newTires = localAccount.axleTirePreference.axleTireDetails.filter(tp => !!tp.isErs).map(t => {
			return new TireDomain(
				t.axleTypeId, 
				t.priority, 
				t.tireApplicationId, 
				'Await Verbal Instruction', 
				t.isRetread, 
				t.brandId, 
				t.sizeId, 
				t.size.name, 
				t.treadId, 
				t.loadRangeId, 
				t.id, 
				null, 
				t.comments, 
				t.isErs, 
				false, 
				false, 
				t.createdAt, 
				t.updatedAt)
		})
	}

	if (newTires.length === 0) { 
		newTires = []
	}

	object.newTires = newTires
	let newWheels = []

	if (localAccount.axleWheelPreference && localAccount.axleWheelPreference.axleWheelDetails) {
		newWheels = localAccount.axleWheelPreference.axleWheelDetails.map(w => {
			// const datWheel = new WheelDomain(w.wheelDiameterId, w.wheelOffset, w.wheelMaterialId, w.wheelTypeId, w.color, w.comments, w.id, false, false, w.createdAt, w.updatedAt)
			// datWheel.isCreate = false
			return new WheelDomain(w.wheelDiameterId, w.wheelOffset === null ? -1 : w.wheelOffset, w.wheelMaterialId, w.wheelTypeId, w.color, w.comments, w.id, false, false, w.createdAt, w.updatedAt)
		})
	}

	if (newWheels.length === 0) { 
		newWheels = []
	}
	object.newWheels = newWheels
	object.ersComments = localAccount.ersComments
	object.authorizationPreference = (localAccount.authorizationPreferenceId !== null) ? localAccount.authorizationPreferenceId : 1
	object.disposition = 9
	if (localAccount.axleCheckPreference && localAccount.axleCheckPreference.axleCheckDetails) {
		object.disposition = localAccount.axleCheckPreference.axleCheckDetails[0].dispositionId
	} 

	return object
}

const getPhoneNumberFromContact = (contact) => {
	if (contact.contactNumbers && contact.contactNumbers.length > 0) {
		return contact.contactNumbers[0].number
	} else {
		return ''
	}
}

const getPhoneNumberIdFromContact = (contact) => {
	if (contact.contactNumbers && contact.contactNumbers.length > 0) {
		return contact.contactNumbers[0].id
	} else {
		return ''
	}
}


// WEBPACK FOOTER //
// ./src/reducers/util/loadLbbPref.js